import { useConfig } from '~/hooks/api/use-config';
import { selectClientName, useStore } from '~/store';
import { ConfigurationContext } from './context';

type Props = React.PropsWithChildren;

export const ConfigurationProvider = (props: Props) => {
  const { children } = props;
  const clientName = useStore(selectClientName);
  const result = useConfig({ clientName });

  if (result.isPending) {
    return <div>...</div>;
  }

  if (result.isError) {
    throw new Error('Unable to get config');
  }

  return <ConfigurationContext value={result.data}>{children}</ConfigurationContext>;
};
